import React from 'react';

import { Grid } from '../../performance-operations/styles';
import { fetchBreakdown, usePanel } from '../../performance-operations/config';
import SummaryKpis from '../components/SummaryKpis';
import StageMatrixPanel from '../components/StageMatrixPanel';
import UnitStatusPanel from '../components/UnitStatusPanel';
import OverdueAssigneesPanel from '../components/OverdueAssigneesPanel';
import ProcessInsightsPanel from '../components/ProcessInsightsPanel';
import { MATRIX_CODES } from '../config';

// Spec §7.2 — Özet: 12 kolon; KPI 4 + 4 / aşama × durum (12) / birimler (7) + geciken sorumlular (5) / AI (12). Her panel kendi isteğini
// atar ve kendi iskelet/boş/hata durumunu taşır; M03 kartı ile matris tek aşama kırılımı isteğini paylaşır (§19/6).
export default function SummaryTab({ filters, m03Stage, onM03StageChange, onMeta, refreshKey, onChanged }) {
  const key = JSON.stringify(filters);
  const stagePanel = usePanel(() => fetchBreakdown(filters, MATRIX_CODES, 'stage'), [key], !!filters.periodId);
  return (
    <Grid>
      <SummaryKpis filters={filters} stagePanel={stagePanel} m03Stage={m03Stage} onM03StageChange={onM03StageChange} onMeta={onMeta} />
      <StageMatrixPanel filters={filters} panel={stagePanel} onMeta={onMeta} />
      <UnitStatusPanel filters={filters} onMeta={onMeta} />
      <OverdueAssigneesPanel filters={filters} onMeta={onMeta} refreshKey={refreshKey} onChanged={onChanged} />
      <ProcessInsightsPanel filters={filters} refreshKey={refreshKey} onChanged={onChanged} />
    </Grid>
  );
}
